// org-layout.component.html(왼쪽 사이드 내비게이션)의 탭 이름과, 그 아래 각 페이지(h1)의
// 제목이 서로 다른 문구를 쓰면 지금 어느 화면에 들어와 있는지 헷갈린다. 두 곳에 리터럴을
// 각자 적어두면 한쪽만 바뀌었을 때 조용히 어긋나므로(예: 사이드바는 '학급구조'인데 페이지
// 제목은 '팀 구조 관리'), 이 객체 하나를 단일 출처로 양쪽이 함께 참조한다.
export const ORG_NAV_LABELS = {
  dashboard: '대시보드',
  members: '구성원',
  teams: '학급구조',
  teamMembers: '학생 명단',
  managedUsers: '학생 계정',
  labels: '멤버 분류',
  permissions: '권한 설정',
  auditLog: '감사 로그',
  continuity: '다년 연속성',
  teamServiceSettings: '서비스 설정',
} as const;
